// Application entrypoint
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';
// Import stylesheets
import '../stylesheets/application.scss'

// Import jQuery and make it available globally
import $ from 'jquery'
import jQuery from 'jquery'
window.$ = $
window.jQuery = jQuery

// Import Font Awesome configuration
import '../javascripts/fontawesome-config.js'

// Import Slick carousel
import 'slick-carousel'

// Import Remodal from existing project files
import '../javascripts/libs/remodal.js'

// Import bid histories for chart functionality
import '../javascripts/web/bid_histories.js'

// Import other web JavaScript modules
import '../javascripts/web/remaining-time.js'
import '../javascripts/libs/flash-message.js'
import '../javascripts/web/search-box.js'
import '../javascripts/web/thumbnail.js'
import '../javascripts/web/contact.js'
import '../javascripts/web/stripe.js'
import '../javascripts/web/remodal.js'
import '../javascripts/web/age-confirm'

// Initialize Rails UJS
import Rails from '@rails/ujs'
Rails.start()
// Make Rails available globally
window.Rails = Rails


document.addEventListener("DOMContentLoaded", () => {
  const sidebar = document.querySelector('.sidebar');
  if (sidebar) {
    OverlayScrollbars(sidebar, {
      className: 'os-theme-light',
      scrollbars: {
        autoHide: "move"
      }
    });
  }
  // Initialize top cover products carousel with responsive settings
  const onResize = () => {
    const count = Math.floor(window.innerWidth / 180)
    $('.top-cover-products').slick({
      slidesToShow: count,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      infinite: true,
      speed: 500
    })
  }

  // Initialize on resize
  $(window).on('resize', onResize)
  requestAnimationFrame(onResize)

  // Initialize any other slick carousels with default settings
  $('.slick').not('.top-cover-products').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  })

  // Remodal event handlers are now imported from web/remodal.js

  // SP menu toggle functionality
  const $body = $('body')
  $('.sp-menu-button').on('click', (e) => {
    $body.toggleClass('sp-menu-open')
  })
  $('.sp-menu-slide').on('click', (e) => {
    if ($(e.target).hasClass('sp-menu-slide')) {
      $body.toggleClass('sp-menu-open')
    }
  });
});

console.log('Vite + Rails + TypeScript Application')